export const governorateEnum = {
  GOV_1: 'GOV_1',
  GOV_2: 'GOV_2',
  GOV_3: 'GOV_3',
  GOV_4: 'GOV_4',
  GOV_5: 'GOV_5',
  GOV_6: 'GOV_6',
  GOV_7: 'GOV_7',
  GOV_8: 'GOV_8',
  GOV_9: 'GOV_9',
  GOV_10: 'GOV_10',
  GOV_11: 'GOV_11',
  GOV_12: 'GOV_12',
  GOV_13: 'GOV_13',
  GOV_14: 'GOV_14',
  GOV_15: 'GOV_15',
  GOV_16: 'GOV_16',
  GOV_17: 'GOV_17',
  GOV_18: 'GOV_18',
  GOV_19: 'GOV_19'
}

export const governorateTranslationMap = {
  [governorateEnum.GOV_1]: 'common_form_input_governorate_gov1',
  [governorateEnum.GOV_2]: 'common_form_input_governorate_gov2',
  [governorateEnum.GOV_3]: 'common_form_input_governorate_gov3',
  [governorateEnum.GOV_4]: 'common_form_input_governorate_gov4',
  [governorateEnum.GOV_5]: 'common_form_input_governorate_gov5',
  [governorateEnum.GOV_6]: 'common_form_input_governorate_gov6',
  [governorateEnum.GOV_7]: 'common_form_input_governorate_gov7',
  [governorateEnum.GOV_8]: 'common_form_input_governorate_gov8',
  [governorateEnum.GOV_9]: 'common_form_input_governorate_gov9',
  [governorateEnum.GOV_10]: 'common_form_input_governorate_gov10',
  [governorateEnum.GOV_11]: 'common_form_input_governorate_gov11',
  [governorateEnum.GOV_12]: 'common_form_input_governorate_gov12',
  [governorateEnum.GOV_13]: 'common_form_input_governorate_gov13',
  [governorateEnum.GOV_14]: 'common_form_input_governorate_gov14',
  [governorateEnum.GOV_15]: 'common_form_input_governorate_gov15',
  [governorateEnum.GOV_16]: 'common_form_input_governorate_gov16',
  [governorateEnum.GOV_17]: 'common_form_input_governorate_gov17',
  [governorateEnum.GOV_18]: 'common_form_input_governorate_gov18',
  [governorateEnum.GOV_19]: 'common_form_input_governorate_gov19',
}



// WEBPACK FOOTER //
// ./src/constants/governorate.js